var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWalet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0887 48.1709V54.7426C63.0887 57.6473 60.736 60 57.8313 60H5.25739C2.35268 60 0 57.6473 0 54.7426V12.6835C0 15.5882 2.35268 17.9409 5.25739 17.9409H57.8313C60.736 17.9409 63.0887 20.2935 63.0887 23.1983V29.77H49.9452C44.8587 29.77 40.7448 33.8839 40.7448 38.9704C40.7448 44.057 44.8587 48.1709 49.9452 48.1709H63.0887Z",
    fill: "#3B7CD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0883 32.3987V45.5422H49.9448C46.3172 45.5422 43.373 42.598 43.373 38.9704C43.373 35.3428 46.3172 32.3987 49.9448 32.3987H63.0883ZM52.5735 38.9704C52.5735 37.5233 51.3906 36.3417 49.9448 36.3417C48.499 36.3417 47.3161 37.5233 47.3161 38.9704C47.3161 40.428 48.499 41.5991 49.9448 41.5991C51.3906 41.5991 52.5735 40.4294 52.5735 38.9704Z",
    fill: "#3B7CD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.202 12.6834V15.3121H53.4014L50.6807 10.0547H52.5733C54.0191 10.0547 55.202 11.2377 55.202 12.6834Z",
    fill: "#3B7CD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6859 6.09857L50.4438 15.3122H33.5413L42.216 10.8434L39.8107 6.17743L22.067 15.3122H10.5928L39.7319 0.289149C41.0331 -0.368025 42.6103 0.131426 43.2806 1.41817L45.6859 6.09857Z",
    fill: "#ECA50C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0626 10.0547L4.90273 15.2845C3.60152 15.1137 2.62891 13.9978 2.62891 12.6834C2.62891 11.2363 3.81182 10.0547 5.2576 10.0547H15.0626Z",
    fill: "#3B7CD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalet);
export default __webpack_public_path__ + "static/media/iconWalet.9178f9f63345f4201ef1639536ad8626.svg";
export { ForwardRef as ReactComponent };